<div>
    <ct-menu #ctmenu [loggedUser]="loggedUser" [profileView]="'home/view/AC_VI00'" *ngIf="!this.isFullScreen"></ct-menu>
    <ct-navbar (menuClick)="onMenuHomeClick()" *ngIf="!this.isFullScreen"></ct-navbar>
    <div *ngIf="ctMenuAvailable && !this.isFullScreen" 
         (click)="onShadowClick()" 
         [class.shadow-box]="this.ctMenu.getIsOpen() && this.ctMenu.getIsTablet()"
         [class.user-select-none]="this.ctMenu.getIsOpen() && this.ctMenu.getIsTablet()"></div>
    
    <router-outlet></router-outlet>

    <div *ngIf="socialMediaVisiable" class="redes"  [@fadeInOut]>
        <a href="https://www.callmyway.com/Welcome/ClickToCallSupport/e32a84f6848c01d42d00b7bde3a4bf3b"
        target="_blank" onclick="gtag('event', 'clickCallMyWay');" class="contact-circle" (click)="toggleSsmnContacts()">
            <i class="fa fa-phone"></i>
        </a>
        <a href="https://webchat.sociedaddesegurosdevida.cr/ssvmn/webchat.php" target="_blank"
                onclick="gtag('event', 'clickContactChat');" class="contact-circle" (click)="toggleSsmnContacts()">
            <i class="fa fa-comments"></i>
        </a>
    </div>

    <div class="ssvmn-contacs-container contact-circle d-flex justify-content-center align-items-center" (click)="toggleSsmnContacts()">
        <img class="customer-serviceimg" src="../assets/imgs/customer-service.png">
    </div>
</div>